<div class="wrapper" (click)="onSelect()">

  <div class="titleContainer">
    <tun-scrollable-text class="title" [text]="musicCollection.title"></tun-scrollable-text>
  </div>

  @if (!isPlaylist) {
    <tun-tweak-context-icon-v5 class="icon icon-scaled-svg-button"></tun-tweak-context-icon-v5>
  }
  @if (isPlaylist) {
    <tun-tweak-playlist-icon-v5 class="icon icon-scaled-svg-button"></tun-tweak-playlist-icon-v5>
  }
</div>
